module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "py-4"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-4": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "rpw": "",
      "wrap": "",
      "pb-4": _vm.$vuetify.breakpoint.smAndDown
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": "",
      "lg4": "",
      "px-4": ""
    }
  }, [(!_vm.isLocalAdmin) ? _c('v-autocomplete', {
    attrs: {
      "required": "",
      "disabled": _vm.isEdit,
      "loading": _vm.companyLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompany)); }],
      "items": _vm.mappedCompanies,
      "label": _vm.$lang.actions.selectCompany
    },
    model: {
      value: (_vm.selectedCompany),
      callback: function($$v) {
        _vm.selectedCompany = $$v
      },
      expression: "selectedCompany"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "md6": "",
      "lg4": "",
      "px-4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": _vm.$lang.labels.sequenceNumber
    },
    model: {
      value: (_vm.sequenceNumber),
      callback: function($$v) {
        _vm.sequenceNumber = $$v
      },
      expression: "sequenceNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mx-4 primary",
    attrs: {
      "disabled": _vm.editingName
    },
    on: {
      "click": _vm.addName
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.addTableName))]), _vm._v(" "), _c('div', {
    staticClass: "nameTable v-table__overflow px-4"
  }, [_c('table', {
    staticClass: "v-datatable v-table theme--light"
  }, [_c('tbody', _vm._l((_vm.names), function(name, index) {
    return _c('tr', {
      key: index
    }, [(name.isEdit) ? [_c('td', [_c('v-select', {
      staticClass: "min-w",
      attrs: {
        "items": _vm.languages,
        "item-text": "text",
        "item-value": "value",
        "label": _vm.$lang.actions.selectLanguage
      },
      model: {
        value: (_vm.tempName.language),
        callback: function($$v) {
          _vm.$set(_vm.tempName, "language", $$v)
        },
        expression: "tempName.language"
      }
    })], 1), _vm._v(" "), _c('td', [_c('v-text-field', {
      staticClass: "min-w",
      attrs: {
        "placeholder": _vm.$lang.labels.name
      },
      model: {
        value: (_vm.tempName.name),
        callback: function($$v) {
          _vm.$set(_vm.tempName, "name", $$v)
        },
        expression: "tempName.name"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "min-w-lg px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      attrs: {
        "disabled": !_vm.tempName.language || !_vm.tempName.name
      },
      on: {
        "click": function($event) {
          return _vm.saveNameEdit(name)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.save) + "\n                ")]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.closeNameEdit(name)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.cancel))])], 1)] : [_c('td', [_vm._v(_vm._s(name.language))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(name.name))]), _vm._v(" "), _c('td', {
      staticClass: "actions px-0"
    }, [_c('v-btn', {
      staticClass: "primary elevation-1",
      on: {
        "click": function($event) {
          return _vm.editName(name)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.edit))]), _vm._v(" "), _c('v-btn', {
      staticClass: "error ml-0 elevation-1",
      on: {
        "click": function($event) {
          return _vm.deleteName(index)
        }
      }
    }, [_vm._v(_vm._s(_vm.$lang.actions.delete))])], 1)]], 2)
  }), 0)])]), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('h3', {
    staticClass: "pa-3"
  }, [_vm._v(_vm._s(_vm.$lang.header.properties))]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary mx-0"
    },
    on: {
      "click": function($event) {
        return _vm.addPropertyCode()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.labels.addProperty) + "\n          ")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "pb-3": ""
    }
  }, [(_vm.properties) ? _c('v-data-table', {
    staticClass: "elevation-0 mt-2",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.properties,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.name))]), _vm._v(" "), (['desktop.image', 'tablet.image'].includes(props.item.name)) ? _c('td', [_c('v-img', {
          attrs: {
            "src": props.item.value,
            "contain": "",
            "height": "100"
          }
        })], 1) : _c('td', [_vm._v(_vm._s(props.item.value))]), _vm._v(" "), _c('td', [_c('v-btn', {
          staticClass: "primary mx-0",
          on: {
            "click": function($event) {
              return _vm.editPropertyCode(props.item)
            }
          }
        }, [_vm._v("\n                  " + _vm._s(_vm.$lang.actions.edit) + "\n                ")]), _vm._v(" "), _c('v-btn', {
          staticClass: "error mx-0",
          on: {
            "click": function($event) {
              return _vm.confirmDeletePropertyCode(props.item)
            }
          }
        }, [_vm._v("\n                  " + _vm._s(_vm.$lang.actions.delete) + "\n                ")])], 1)]
      }
    }], null, false, 2694922300)
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [(_vm.isEdit && _vm.createdOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.created,
      "readonly": ""
    },
    model: {
      value: (_vm.createdOn),
      callback: function($$v) {
        _vm.createdOn = $$v
      },
      expression: "createdOn"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isEdit && _vm.modifiedOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.modified,
      "readonly": ""
    },
    model: {
      value: (_vm.modifiedOn),
      callback: function($$v) {
        _vm.modifiedOn = $$v
      },
      expression: "modifiedOn"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3 px-2",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-content-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-3",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'tableCategories'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n          " + _vm._s(_vm.$lang.actions.close) + "\n        ")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-3",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$lang.actions.submit) + "\n        ")])], 1)], 1)], 1), _vm._v(" "), (_vm.propertyModal) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "1200"
    },
    model: {
      value: (_vm.propertyModal),
      callback: function($$v) {
        _vm.propertyModal = $$v
      },
      expression: "propertyModal"
    }
  }, [_c('properties-modal', {
    attrs: {
      "title": _vm.isPropertyEdit ? 'Edit Property' : 'Add Property',
      "htmlCode": _vm.propertyCodeToEdit,
      "isHtmlEdit": _vm.isPropertyEdit,
      "htmlKeysListFiltered": _vm.propertiesKeysListFiltered
    },
    on: {
      "submit": function($event) {
        return _vm.savePropertiesCode($event)
      },
      "close": function($event) {
        _vm.propertyModal = false, _vm.propertyCodeToEdit = null, _vm.tempIndex = null
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.confirmationModal) ? _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "500"
    },
    model: {
      value: (_vm.confirmationModal),
      callback: function($$v) {
        _vm.confirmationModal = $$v
      },
      expression: "confirmationModal"
    }
  }, [_c('confirmation-modal', {
    attrs: {
      "text": _vm.$lang.actions.deleteProperty
    },
    on: {
      "submit": function($event) {
        return _vm.deletePropertyCode()
      },
      "close": function($event) {
        _vm.confirmationModal = false;
        _vm.tempIndex = null
      }
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cf3a2c2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tables/TableCategoryDetail.vue
// module id = 402
// module chunks = 35